import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OrderQueueScan } from '../../components/OrderQueueScan';
import { QueueList } from '../../components/QueueList';
import { TaskCard } from '../../components/TaskCard';
import { TaskMeta } from '../../components/TaskMeta';
import { taskEntered } from '../../../../features/operator/operatorDeviceSlice';
import { OPERATOR_FLOW } from '../../../../features/operator/operatorConstants';
import { orderCardTitle } from '../../../../features/operator/operatorUtils';
import { fetchPackingQueue } from '../../../../features/operatorPacking/operatorPackingThunks';
import { measuredItemsText } from '../../../../features/operatorPacking/operatorPackingUtils';
import { formatQuantity, wmsOrderStateLabel } from '../../../../utils/inventoryLabels';

/** Empaque: the picked orders waiting to be packed, in the tray's order. Scanning an order opens it. */
export const PackingQueue = () => {
  const dispatch = useDispatch();
  const { queue } = useSelector((state) => state.operatorPacking);

  useEffect(() => {
    dispatch(taskEntered({ flow: OPERATOR_FLOW.PACKING }));
    dispatch(fetchPackingQueue({ page: 1 }));
  }, [dispatch]);

  return (
    <div className="space-y-5">
      <OrderQueueScan flow={OPERATOR_FLOW.PACKING} />

      <QueueList
        queue={queue}
        testId="packing-order-list"
        emptyText="No hay órdenes por empacar."
        onRetry={() => dispatch(fetchPackingQueue({ page: 1 }))}
        onMore={() => dispatch(fetchPackingQueue({ page: queue.page + 1 }))}
        onRefresh={() => dispatch(fetchPackingQueue({ page: 1 }))}
        refreshThunk={fetchPackingQueue}
      >
        {queue.items.map((order) => (
          <li key={order.id}>
            <TaskCard
              to={`/packing/${order.id}`}
              testId="packing-order-card"
              data={{ 'data-order-id': order.id }}
              title={orderCardTitle(order)}
              subtitle={[
                order.recipient,
                order.company_name,
                `${formatQuantity(order.units)} un`,
                order.items_count ? measuredItemsText(order.items_measured, order.items_count) : 'sin bultos',
              ]
                .filter(Boolean)
                .join(' · ')}
              aside={
                <span className="rounded-full border border-border px-2.5 py-0.5 text-xs font-semibold text-text-secondary">
                  {wmsOrderStateLabel(order.wms_state)}
                </span>
              }
            >
              <TaskMeta task={order} />
            </TaskCard>
          </li>
        ))}
      </QueueList>
    </div>
  );
};
